
import { mapGetters } from 'vuex'
import initBargainSuccess from './initBargainSuccess.vue'
import GoodsIntroduce from '@/components/GoodsDesc/GoodsIntroduce'
// import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
import { bargainStatus, RestrictMallCode } from '@/enum/localEnum'
import { deleteFixedEnName, mappingFieldToStr, addBlankPath, toDom } from '@/utils/validate'
import { thirdPartyServiceUrl, openHackBargain } from '@/settings'
import Breadcrumb from '@/components/Breadcrumb'
import { filterDirtyHTML } from '@/utils/filter-dirty-html'
import { debounce, formatCount } from '@/utils'
import BargainDialog from '@/components/BargainDialog.vue'
import PzTabs from '@/components/pz-tabs'
import Collect from '@/components/GeneralGoodsDetail/Collect.vue'
import ServiceButton from '@/components/GeneralGoodsDetail/ServiceButton.vue'
import SimilarBox from '@/components/SimilarBox'
const GoodsTransaction = () => import('@/components/GoodsDesc/GoodsTransaction')
const GoodsQqGroup = () => import('@/components/GoodsDesc/GoodsQqGroup')
const ByStagePay = () => import('@/components/GoodsDesc/ByStagePay')
const GoodsWrap = () => import('@/components/GoodsWrap')
const TimeCountdown = () => import('@/components/TimeCountdown')
const realNameModel = () => import('@/components/realNameModel')
import { getReleaseTimeString } from '@/utils'

export default {
    components: {
        realNameModel,
        TitleBox2,
        initBargainSuccess,
        GoodsIntroduce,
        GoodsTransaction,
        GoodsWrap,
        TimeCountdown,
        GoodsQqGroup,
        Breadcrumb,
        BargainDialog,
        ByStagePay,
        PzTabs,
        Collect,
        ServiceButton,
        SimilarBox
    },
    watch: {
        bargainingState(val) {
            if (val) {
                // 判断是否是点击砍价卡片
                this.onekeyBargain()
                this.$store.commit('SET_BARGAINING_STATE', false)
            }
        },
        couponInfo: {
            handler(val) {
                if (Object.keys(val).length) {
                    if (this.token) {
                        this.isShowTag = val.isTargetUser
                        this.isShowCoupon = !val.isTargetUser && val.userMaxCouponVO
                        if (this.isShowCoupon) {
                            this.couponContInfo = { ...val.userMaxCouponVO }
                        }
                    } else {
                        this.isShowTag = true
                        this.isShowCoupon = false
                    }
                } else {
                    this.isShowTag = true
                    this.isShowCoupon = false
                }
            },
            immediate: true,
            deep: true
        },
        'detailsData.goodsNo': {
            immediate: true,
            handler(no) {
                if (!no) return
                this.getWantAndSeenNum(no)
            }
        },
        shareEndTime: {
            handler(val) {
                if (val) {
                    this.startCountdown()
                }
            },
            immediate: true
        }
    },

    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            token: 'user/token',
            bargainingState: 'bargainingState',
            customerInfo: 'ry/customerInfo',
            /**
             * 公共剩余砍价次数
             */
            bargainCountConfig: 'bargain/bargainCountConfig',
            bargainBoxList: 'bargaining/bargainBoxList'
        }),
        propertyConfigLabel() {
            const arr = ['label1', 'label2', 'label3']
            const tag = []
            arr.map(item => {
                if (this.detailsData[item] && this.detailsData[item + 'Name']) {
                    tag.push({
                        [item]: this.detailsData[item],
                        labelName: this.detailsData[item + 'Name']
                    })
                }
            })
            return tag
        },
        releaseTimeString() {
            return getReleaseTimeString(this.detailsData.onStandTime)
        },
        shareEndTime() {
            return this.detailsData?.shareEndTime
        },
        topTabs() {
            return this.tabTitle.map(item => ({
                ...item,
                name: item.value,
                label: item.title
            }))
        }
    },
    async asyncData({ app, params, route }) {
        try {
            const detailsPar = {
                action: {
                    goodsNo: params.goodsNo
                }
            }
            const { searchWords, gameId } = route.query
            if (searchWords && gameId) {
                detailsPar.action = {
                    ...detailsPar.action,
                    searchWords: searchWords ? [searchWords] : [],
                    gameId: +gameId
                }
            }
            const res = await app.$api.goodsDetails(detailsPar)
            const p = {
                action: {
                    gameId: res?.data?.gameId,
                    goodsCatalogueId: res?.data?.goodsCatalogueId,
                    inSell: true
                }
            }
            const config = await app.$api.goodsListPropertyConfig(p)
            // 商品介绍的基本属性
            const propertyConfig = config?.data?.filter(item => item.showDetails)
            // 封面图片位置的基本属性
            const baseConfig = config?.data?.filter(item => item.showDetails && item.recommend)
            return {
                BAIDU_URL: process.env.BAIDU_URL + route.path,
                BAIDU_DATE: res?.data?.updateTime == null || res?.data?.updateTime == '' ? '' : res?.data?.updateTime?.replace(' ', 'T'),
                BAIDU_PUSH_DATE: res?.data?.onStandTime?.replace(' ', 'T'),

                detailsData: {
                    ...res?.data,
                    goodsImg: res?.data?.goodsImg ? res?.data?.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg') : null
                },
                goodsNo: params?.goodsNo,
                goodsType: parseInt(res?.data?.goodsCatalogueId),
                backListPath: {
                    goodsCatalogueId: res?.data?.goodsCatalogueId,
                    gameId: res?.data?.gameId
                },
                propertyConfig: deleteFixedEnName(propertyConfig),
                propertyRecommendConfig: deleteFixedEnName(baseConfig),
                sellerId: res?.data?.sellerId,
                // sellerIsOnline: findSellerOnlineStates?.data
            }
        } catch (error) { }
    },
    data() {
        return {
            timedown: null,
            cancelDia: false,
            realNameModelState: false,
            realNameSuccessCb: null,
            openHackBargain,
            show: true,
            unlockTime: null,
            timers: null,
            dialogUnlockTimeVisible: false, // 锁定砍价
            bargained: false, // 用户是否已砍价
            bargainedData: {}, // 用户已砍价的数据
            dialogKanVisible: null,
            tabNavFixed: false,
            tabTitle: [],
            tabTitleName: '',
            // backListPath: null,
            customerServiceObj: null,

            tradingNoticeData: [], // 交易须知
            serviceData: [], // 客服交易群
            cusUrl: 'https://tb.53kf.com/code/code/58ad4443ed6e531a00699b7d703db3262/',
            cancelableTimes: null,
            centerDialogVisible2: false, // 购买须知
            articleDetail: null,
            hagglingDetail: '', // 砍价须知详情
            bargainCheck: null, // 砍价信息
            bargainLoading: false, // 砍价loading
            stagePayConfig: {
                isShow: false
            }, // 分期代付
            couponInfo: {}, // 最优优惠券
            isShowTag: false,
            isShowCoupon: false,
            couponContInfo: {},
            wantNum: 0,
            seenNum: 0,
            wantBuyText: '',
            seenText: '',
            userCarouselList: [],
            countdownTime: ['00', '00', '00'],
            countdownTimer: null,
            sellerIsOnline: false,
            couponLoaded: false, // 避免优惠券数据加载时闪烁
            disabledStatusList: [
                'TRADING', //交易中
                'BEAN_SOLD', //已出售
                'FORCE_DOWN_STAND', //强制下架
                'ONESELF_DOWN_STAND', //自行下架
            ],
        }
    },
    head() {
        if (!this.$config.isPublicProd) { return {} }
        return {
            title: `${this.detailsData.simpleMessage}_账号编号${this.detailsData.goodsNo}出售-盼之代售-手游网游账号买号卖号平台`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: `盼之代售为您提供${this.detailsData.simpleMessage}游戏区服账号出售，商品编号${this.detailsData.goodsNo}，售价：${this.detailsData.price}，盼之代售为您提供安全无忧的账号购买服务`
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: `${this.detailsData.gameIdName}游戏交易平台,${this.detailsData.gameIdName}游戏账号交易`
                }
            ],
            script: [
                {
                    hid: 'ldjson-schema',
                    innerHTML: `{"@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonid","@id":"https://${this.BAIDU_URL}","pubDate": "${this.BAIDU_PUSH_DATE}","upDate": "${this.BAIDU_DATE}"}`,
                    type: 'application/ld+json'
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    },
    methods: {
        // 计算倒计时
        calculateCountdown() {
            const now = new Date().getTime()
            const endTime = new Date(this.shareEndTime?.replace(/-/g, '/')).getTime()

            const diffMs = endTime - now

            if (diffMs <= 0) {
                // 倒计时结束
                this.countdownTime = ['00', '00', '00']
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer)
                    this.countdownTimer = null
                }
                return
            }

            // 计算时分秒
            const totalSeconds = Math.floor(diffMs / 1000)
            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const seconds = totalSeconds % 60

            // 格式化为两位数
            this.countdownTime = [
                hours.toString().padStart(2, '0'),
                minutes.toString().padStart(2, '0'),
                seconds.toString().padStart(2, '0')
            ]
        },
        async getSellerIsOnline() {
            if (this.sellerId) {
                try {
                    const res = await this.$api.findSellerOnlineStates({ sellerId: this.sellerId })
                    console.log('res', res)
                    if (res.success) {
                        this.sellerIsOnline = res.data
                    }
                } catch (error) {
                    console.log('findSellerOnlineStates error', error)
                }
            }
        },
        startCountdown() {
            this.calculateCountdown() // 立即计算一次

            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
            }

            this.countdownTimer = setInterval(() => {
                this.calculateCountdown()
            }, 1000)
        },
        clearCountdownTimer() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
                this.countdownTimer = null
            }
        },
        async getWantAndSeenNum() {
            const goodsNo = this.detailsData.goodsNo
            const onStandTime = this.detailsData.onStandTime
            try {
                const res = await this.$api.getGoodsWantAndSeenNum({ action: [{ goodsNo, onStandTime }] })
                if (res.success) {
                    this.wantNum = res.data[0].wantNum || 0
                    this.seenNum = res.data[0].seenNum || 0
                    this.wantBuyText = formatCount(this.wantNum)
                    this.seenText = formatCount(this.seenNum)
                }
            } catch (err) {
                console.log(err)
            }
        },
        handleCouponClick() {
            window.location.href = 'https://m7.pzds.com/lego-activity/#/packages/activity/lego/lego?activityId=4'
        },
        // 商详页最优优惠劵计算
        async getOptimalCoupon(payOnline) {
            try {
                const { goodsNo } = this.$route.params
                const data = {
                    goodsNo,
                    payOnline
                }
                const res = await this.$api.optimalCoupon(data)
                if (!res.success) return this.$message.error(res.info)
                this.couponInfo = { ...res.data }
                this.couponLoaded = true

            } catch (error) {
                this.couponLoaded = true
                this.$message.error(error.message)
            }
        },
        // 开启已砍价弹窗
        openBargainedTipsDialog(bargainOrderNo) {
            const model = this.$pzDialog(
                {
                    width: '450px',
                    title: '温馨提示',
                    titleCenter: true,
                    cancelButtonText: '稍后查看',
                    confirmButtonText: '查看砍价详情',
                    content: '该商品您已发起砍价～',
                    contentCenter: true,
                    onConfirm: () => {
                        this.$router.push(`/account/bargainMe/details?bargainOrderNo=${bargainOrderNo}`)
                        model.remove()
                    },
                    onCancel: async () => {
                        model.remove()
                    }
                },
                this
            )
        },
        // 打开发起砍价成功提醒弹窗
        openInitBargainSuccessDialog() {
            const model = this.$pzDialog(
                {
                    width: '450px',
                    title: '发起砍价成功',
                    cancelButtonText: '查看详情',
                    confirmButtonText: '浏览其他商品',
                    showClose: true,
                    titleCenter: false,
                    component: initBargainSuccess,
                    onConfirm: () => {
                        this.dialogKanVisible = false
                        if (window.close) {
                            // For IE and Firefox
                            window.close()
                        } else {
                            // For Chrome and Safari
                            window.open('', '_self', '')
                            window.close()
                        }
                        model.remove()
                    },
                    onCancel: async () => {
                        this.$router.push('/account/bargainMe')

                        model.remove()
                    }
                },
                this
            )
        },
        // 展开
        getDingyue() {
            if (process.client) {
                this.$el?.querySelector('.getDwei').scrollIntoView({ block: 'start', behavior: 'smooth' })
            }
        },
        countDownEnd() {
            this.dialogUnlockTimeVisible = false
        },
        // 处理砍价表单提交
        handleBargainSubmit(price) {
            this.bargainLoading = true
            const params = {
                action: {
                    goodsNo: this.detailsData.goodsNo,
                    price: parseFloat(price),
                    buyerId: this.userinfo.id
                }
            }
            this.$api
                .bargainImCreateAPI(params)
                .then(res => {
                    this.$trackEvent({
                        eventType: 'click',
                        trackParams: { eventName: '确认出价', userId: this.userinfo.id, goodsNo: this.detailsData.goodsNo, bidTime: Date.now(), isSuccess: res.success }
                    })
                    if (!res.success) {
                        this.bargainLoading = false
                        if (res.code === 'BARGAIN_IM_REPETITION') {
                            const model = this.$pzDialog(
                                {
                                    width: '450px',
                                    title: '温馨提示',
                                    titleCenter: true,
                                    confirmButtonText: '',
                                    cancelButtonText: '我知道了',
                                    content: res.info,
                                    contentCenter: true,
                                    showCancelButton: false,
                                    onCancel: () => {
                                        model.remove()
                                    }
                                },
                                this
                            )
                            return
                        }
                        this.$message.error(res.info)
                        return
                    }
                    const { sellerAgree, sellerReject, sellerReply } = res?.data?.operate || {}
                    sellerAgree && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '同意砍价', ...sellerAgree } })
                    sellerReject && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '卖家拒绝', ...sellerReject } })
                    sellerReply && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '砍价回复', ...sellerReply } })
                    setTimeout(() => {
                        this.bargainLoading = false
                        this.dialogKanVisible = false
                        this.$message.success('砍价成功~')
                        const item = this.bargainBoxList.find(item => item.sessionId === res.data.sessionId)
                        this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
                        this.$store.commit('bargaining/SET_CURRENT_BARGAIN', item)
                        this.$store.commit('ry/SET_CUSTOMER_INFO', {})
                    }, 1000)
                })
                .catch(err => {
                    this.bargainLoading = false
                    console.error(err)
                })
        },
        mappingFieldToStrHandle(detailsData, item) {
            return mappingFieldToStr(detailsData, item)
        },
        /**
         * 切换商品描述的tab
         */
        checkTabTitle(item) {
            this.tabTitleName = item.value
            if (item.value === 'tradingNotice' && !this.tradingNoticeData.length) {
                this.getListTradingNotice()
            }
            if (item.value === 'qqGroup' && !this.serviceData.length) {
                this.getListCustomerService()
            }

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop > 599) {
                toDom(document?.querySelector('#contentTop'), 0)
            }
        },
        handleGoodsScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            this.tabNavFixed = scrollTop >= 599 ? true : null
        },
        /**
         * 获取活的配置项
         */
        getGoodsListPropertyConfig() {
            const p = {
                action: {
                    gameId: this.detailsData.gameId,
                    goodsCatalogueId: this.detailsData.goodsCatalogueId,
                    inSell: true
                }
            }
            this.$api.goodsListPropertyConfig(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                const data = res.data
                // 商品介绍的基本属性
                const propertyConfig = data.filter(item => item.showDetails)
                this.propertyConfig = deleteFixedEnName(propertyConfig)
                // 封面图片位置的基本属性
                const baseConfig = data.filter(item => item.showDetails && item.recommend)
                this.propertyRecommendConfig = deleteFixedEnName(baseConfig)
            })
        },
        /** 砍价或者取消砍价 **/
        showKan: debounce(async function () {
            console.log(this.detailsData, '123123')
            if (!this.detailsData.bargain) {
                this.$message.warning('卖家设置商品不可砍价')
                return
            }
            // window._czc && window._czc.push(['_trackEvent', '点击', '商品详情页面', '砍价购买', this.$route.params.goodsNo])
            if (!this.token) {
                this.$message.warning('请先登录')
                this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
                return
            }

            // 获取实名前先调接口
            await this.$store.dispatch('user/UserGetInfo')
            if (!this.userinfo?.isRealName) {
                this.realNameModelState = true
                this.realNameSuccessCb = this.realNameKan
                return
            }

            this.realNameKan()

        }),
        realNameKan() {
            // 检查是否被限制砍价
            const isRestrict = this.$store?.getters?.['user/checkUserRestrictMall'](RestrictMallCode.BARGAIN_CREATE)
            if (isRestrict) {
                return
            }

            // 是否处于共享秒杀期
            if (this.detailsData.share) {
                const model = this.$pzDialog(
                    {
                        width: '450px',
                        title: '温馨提示',
                        titleCenter: true,
                        cancelButtonText: '再砍一刀',
                        confirmButtonText: '我知道了',
                        content: '当前价格已经是秒杀价啦，再砍一刀卖家同意概率很低哦～',
                        contentCenter: false,
                        onConfirm: () => {
                            model.remove()
                        },
                        onCancel: async () => {
                            model.remove()
                            this.openBargainDialog()
                        }
                    },
                    this
                )
                return
            }

            this.openBargainDialog()
        },

        // 打开砍价弹窗
        openBargainDialog() {
            const params = {
                action: {
                    goodsNo: this.detailsData.goodsNo,
                    userId: this.userinfo.id
                }
            }
            this.$api.bargainImEntranceCheckAPI(params).then(({ success, data, info }) => {
                if (success && data) {
                    // 检查砍价信息
                    this.bargainCheck = data
                    // 已存在砍价
                    if (data.sessionId) {
                        const item = this.bargainBoxList.find(item => item.sessionId === data.sessionId)
                        this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
                        this.$store.commit('bargaining/SET_CURRENT_BARGAIN', item)
                        this.$store.commit('ry/SET_CUSTOMER_INFO', {})
                    } else {
                        this.dialogKanVisible = true
                    }
                } else {
                    this.$message.error(info)
                }
            })
            // 分界线 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

            // const par = {
            // 	action: {
            // 		goodsNo: this.detailsData.goodsNo
            // 	}
            // }
            // const res = await this.$api.checkHasBargain(par)
            // if (!res.data) {
            // 	this.$message.error(res.info)
            // 	return
            // }
            // if (res.data.bargainOrderNo) {
            // 	this.openBargainedTipsDialog(res.data.bargainOrderNo)
            // 	return
            // }
            // // 获取砍价信息
            // const resPrice = await this.getCurrentGoodsBargainInfo()
            // console.log('🚀 ~ resPrice:', resPrice)
            // if (resPrice?.success) {
            // 	this.dialogKanVisible = true
            // }
        },
        // 一键砍价
        async onekeyBargain() {
            window._czc && window._czc.push(['_trackEvent', '点击', '商品详情页面', '砍价购买', this.$route.params.goodsNo])
            const resPrice = await this.getCurrentGoodsBargainInfo()
            if (!resPrice?.success) {
                return
            }
            // 商品锁定时间
            if (this.bargainedData.bargainLock) {
                this.dialogUnlockTimeVisible = true
                this.unlockTime = this.bargainedData.unlockTime
                return
            }
            this.dialogKanVisible = true
            this.$nextTick(() => {
                this.$refs['kan-input']?.focus()
            })
        },
        /**
         * 检查用户是否砍过价
         */
        checkUserBargain() {
            // if (!this.userinfo) return
            // let p = {
            // 	action: {
            // 		goodsNo: this.detailsData.goodsNo,
            // 		goodsCatalogueId: this.detailsData.goodsCatalogueId
            // 	}
            // }
            // this.$api.bargainGoodsStatus(p).then(res => {
            // 	if (!res.success) {
            // 		this.$message.error(res.info)
            // 		return
            // 	}
            // 	const { bargain, cancelableTimes } = res.data
            // 	this.bargained = bargain
            // 	this.cancelableTimes = cancelableTimes
            // })
        },
        /**
         * 获取砍价须知
         */
        async getHagglingDetail() {
            const par = {
                action: {
                    id: 45
                }
            }
            const res = await this.$api.getHagglingDetail(par)
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            this.hagglingDetail = res.data
        },
        /**
         * 获取最低报价金额
         */
        async getCurrentGoodsBargainInfo() {
            try {
                const par = {
                    action: {
                        goodsNo: this.detailsData.goodsNo
                    }
                }
                const res = await this.$api.bargainCountAndPrice(par)
                if (!res.success) {
                    this.$message.error(res.info)
                    console.log('123', 123)
                    return res
                }
                this.bargainedData = res.data
                this.getHagglingDetail()
                return res
            } catch (err) {
                return err
            }
        },
        /** 买家出价砍价价格 **/
        bargainPriceHandler() {
            return new Promise(resolve => {
                const p = {
                    action: {
                        goodsNo: this.detailsData.goodsNo,
                        goodsCatalogueId: this.detailsData.goodsCatalogueId
                    }
                }
                this.$api.bargainCountAndPrice(p).then(res => {
                    this.bargainedData = res.data
                    resolve(res)
                })
            })
        },
        /** 取消砍价 **/
        bargainCancelBargainHandler() {
            const p = {
                action: {
                    goodsNo: this.detailsData.goodsNo,
                    goodsCatalogueId: this.detailsData.goodsCatalogueId
                }
            }
            this.$api.bargainCancelBargain(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                // this.checkUserBargain()
                this.$message.success(res.info)
            })
        },
        // 查询是否有砍价成功信息
        async getBargainSuccessInfo() {
            const res = await this.$api.getBargainSuccessInfoAPI({ goodsNo: this.$route.params.goodsNo })
            if (!res.success) {
                this.$message.error(res.info)
                return false
            }

            if (!res?.data?.createOrderEndTime) {
                return false
            }

            const { bargainOrderType, imUserId, goodsNo, bargainOrderNo, bargainPrice, gameId } = res.data

            // 线下
            if (Number(bargainOrderType) === bargainStatus.MY_BARGAIN_ENUM.OffLine) {
                if (!imUserId) {
                    return this.$message.error('暂无客服')
                }
                // 413砍价线下单直接跳转客服聊天
                this.$store.dispatch('ry/join', { targetId: imUserId, conversationType: 1 })
                return true
            }

            // 线上
            const order = {
                bargainOrderNo,
                bargainPrice,
                gameId,
                fromGoodsDetail: true
            }
            sessionStorage.setItem('orderDtl', JSON.stringify(order))
            // 没有生成订单则跳转到砍价的订单确认页
            this.$router.push(`/confirmOrder/onlinePay?goodsNo=${goodsNo}`)

            return true
        },
        /**
         * 立即购买
         * @constructor
         */
        buyNow: debounce(async function () {
            this.$trackEvent({ eventType: 'click', trackParams: { eventName: '商详-立即购买按钮点击', goodsNo: this.$route.params.goodsNo, goodsCatalogueName: '成品号' } })
            window._czc && window._czc.push(['_trackEvent', '点击', '商品详情页面', '立即购买', this.$route.params.goodsNo])

            window.collectEvent('buy_now_click', { is_new_user: this.userinfo?.isAbUser ? '1' : '0' })

            if (!this.token) {
                this.$message.warning('请先登录')
                this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
                return
            }

            if (this.token) {
                await this.$store.dispatch('user/UserGetInfo')
                if (!this.userinfo.isRealName) {
                    this.realNameModelState = true
                    this.realNameSuccessCb = this.realNameBuy
                    // this.$confirm('需先完成实名才能购买', '提示', {
                    // 	confirmButtonText: '前去实名',
                    // 	cancelButtonText: '取消',
                    // 	type: 'warning',
                    // 	confirmButtonClass: 'confirmButtonClass'
                    // })
                    // 	.then(() => {
                    // 		// console.log(,'65656')
                    // 		window.localStorage.setItem('realPath', this.$route.path)
                    // 		// addBlankPath("/account/authHome");
                    // 		addBlankPath('/account/realName')
                    // 	})
                    // 	.catch(() => {})
                    return
                }
                this.realNameBuy()

                return

                // 检查是否被限制购买商品
                const isRestrict = this.$store?.getters?.['user/checkUserRestrictMall'](RestrictMallCode.ALL_BUY)
                if (isRestrict) {
                    return
                }
            }

            // 查询是否有砍价成功信息
            const hasBargainSuccess = await this.getBargainSuccessInfo()
            if (hasBargainSuccess) {
                return
            }

            const _info = {
                action: {
                    events: ['BUY_GAME', 'CONSULT_SERVICE_GAME'],
                    eventId: this.detailsData.gameId
                }
            }
            this.$api.getRelatedClicks(_info).then(res => { })

            const _data = {
                action: {
                    goodsNo: this.detailsData.goodsNo
                }
            }
            if (this.detailsData.payOnline == 0) {
                // 线下交易
                if (thirdPartyServiceUrl && this.token) {
                    const info = {
                        action: {
                            gameId: this.detailsData.gameId,
                            goodsCatalogueId: this.detailsData.goodsCatalogueId,
                            goodsNo: this.detailsData.goodsNo
                        }
                    }
                    this.$api.getCustomerService(info).then(res => {
                        if (!res.data) {
                            this.$message({
                                message: '暂无客服值班',
                                type: 'error'
                            })
                            return
                        }

                        const goodsInformation = {
                            goodsId: this.detailsData.goodsNo,
                            gameId: this.detailsData.gameId,
                            price: this.detailsData.price,
                            link: window.location.href,
                            poster: this.detailsData.goodsImg,
                            title: this.detailsData.title,
                            desc: this.detailsData.description,
                            goodsCatalogueId: this.detailsData.goodsCatalogueId,
                            bargain: this.detailsData.bargain,
                            compensation: this.detailsData.compensation
                        }

                        this.$store.dispatch('ry/sendGoodsMsg', {
                            targetId: res.data.id,
                            content: goodsInformation
                        })
                        this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                        this.$store.commit('ry/SET_ORDER_FLOW', [])
                    })
                }
            } else {
                // 线上交易
                // 判断是否是 3.0工单
                // 是就走全款订单详情
                this.$api.getCheckGoodsStatus({ goodsNo: this.detailsData.goodsNo }).then(res => {
                    if (res.success) {
                        this.setSaveUserConsultGoods()
                        if (thirdPartyServiceUrl && this.userinfo.id) {
                            this.$router.push({
                                path: '/confirmOrder/fullPayment',
                                query: {
                                    status: res.data ? 'WAIT_PAY' : 'null',
                                    orderNo: res.data,
                                    gameId: this.detailsData.gameId,
                                    goodsNo: this.detailsData.goodsNo
                                }
                            })
                            sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
                        }
                    } else {
                        // 提示商品状态
                        this.$message.error(res.info)
                    }
                })
                // if (this.detailsData.workOrderTemplateId) {
                // } else {
                // 	// 不是就就老工单
                // 	this.$api.getCheckGoodsStatus({ goodsNo: this.detailsData.goodsNo }).then(res => {
                // 		if (res.success) {
                // 			this.setSaveUserConsultGoods()
                // 			if (thirdPartyServiceUrl && this.userinfo.id) {
                // 				this.$router.push({
                // 					path: '/confirmOrder/orderInfoConfirm',
                // 					query: {
                // 						status: res.data ? 'WAIT_PAY' : 'null',
                // 						orderNo: res.data,
                // 						gameId: this.detailsData.gameId,
                // 						goodsNo: this.detailsData.goodsNo
                // 					}
                // 				})
                // 				sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
                // 			}
                // 		} else {
                // 			// 提示商品状态
                // 			this.$message.error(res.info)
                // 		}
                // 	})
                // }
            }
        }),
        async realNameBuy() {
            // 检查是否被限制购买商品
            const isRestrict = this.$store?.getters?.['user/checkUserRestrictMall'](RestrictMallCode.ALL_BUY)
            if (isRestrict) {
                return
            }

            // 查询是否有砍价成功信息
            const hasBargainSuccess = await this.getBargainSuccessInfo()
            if (hasBargainSuccess) {
                return
            }

            const _info = {
                action: {
                    events: ['BUY_GAME', 'CONSULT_SERVICE_GAME'],
                    eventId: this.detailsData.gameId
                }
            }
            this.$api.getRelatedClicks(_info).then(res => { })

            const _data = {
                action: {
                    goodsNo: this.detailsData.goodsNo
                }
            }
            if (this.detailsData.payOnline == 0) {
                // 线下交易
                if (thirdPartyServiceUrl && this.token) {
                    const info = {
                        action: {
                            gameId: this.detailsData.gameId,
                            goodsCatalogueId: this.detailsData.goodsCatalogueId,
                            goodsNo: this.detailsData.goodsNo
                        }
                    }
                    this.$api.getCustomerService(info).then(res => {
                        if (!res.data) {
                            this.$message({
                                message: '暂无客服值班',
                                type: 'error'
                            })
                            return
                        }

                        const goodsInformation = {
                            goodsId: this.detailsData.goodsNo,
                            gameId: this.detailsData.gameId,
                            price: this.detailsData.price,
                            link: window.location.href,
                            poster: this.detailsData.goodsImg,
                            title: this.detailsData.title,
                            desc: this.detailsData.description,
                            goodsCatalogueId: this.detailsData.goodsCatalogueId,
                            bargain: this.detailsData.bargain,
                            compensation: this.detailsData.compensation
                        }

                        this.$store.dispatch('ry/sendGoodsMsg', {
                            targetId: res.data.id,
                            content: goodsInformation
                        })
                        this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                        this.$store.commit('ry/SET_ORDER_FLOW', [])
                    })
                }
            } else {
                // 线上交易
                // 判断是否是 3.0工单
                // 是就走全款订单详情
                this.$api.getCheckGoodsStatus({ goodsNo: this.detailsData.goodsNo }).then(res => {
                    if (res.success) {
                        this.setSaveUserConsultGoods()
                        if (thirdPartyServiceUrl && this.userinfo.id) {
                            this.$router.push({
                                path: '/confirmOrder/fullPayment',
                                query: {
                                    status: res.data ? 'WAIT_PAY' : 'null',
                                    orderNo: res.data,
                                    gameId: this.detailsData.gameId,
                                    goodsNo: this.detailsData.goodsNo
                                }
                            })
                            sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
                        }
                    } else {
                        // 提示商品状态
                        this.$message.error(res.info)
                    }
                })
                // if (this.detailsData.workOrderTemplateId) {
                // } else {
                // 	// 不是就就老工单
                // 	this.$api.getCheckGoodsStatus({ goodsNo: this.detailsData.goodsNo }).then(res => {
                // 		if (res.success) {
                // 			this.setSaveUserConsultGoods()
                // 			if (thirdPartyServiceUrl && this.userinfo.id) {
                // 				this.$router.push({
                // 					path: '/confirmOrder/orderInfoConfirm',
                // 					query: {
                // 						status: res.data ? 'WAIT_PAY' : 'null',
                // 						orderNo: res.data,
                // 						gameId: this.detailsData.gameId,
                // 						goodsNo: this.detailsData.goodsNo
                // 					}
                // 				})
                // 				sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
                // 			}
                // 		} else {
                // 			// 提示商品状态
                // 			this.$message.error(res.info)
                // 		}
                // 	})
                // }
            }
        },
        /**
         * 咨询客服
         * @constructor
         */
        askService: debounce(function () {
            const btnName = {
                1: '商品咨询',
                2: '咨询客服',
                3: '咨询卖家'
            }[this.detailsData.consultLabel]
            this.$trackEvent({ eventType: 'click', trackParams: { eventName: '商详-发起商品咨询', btnName, goodsNo: this.$route.params.goodsNo, goodsCatalogueName: '成品号' } })
            window._czc && window._czc.push(['_trackEvent', '点击', '商品详情页面', '咨询客服', this.$route.params.goodsNo])
            if (!this.token) {
                this.$message.warning('请先登录')
                this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
                return
            }
            const _info = {
                action: {
                    event: 'CONSULT_SERVICE_GAME',
                    eventId: this.detailsData.gameId
                }
            }
            this.$api.getRelatedClicks(_info).then(res => { })

            // 注册首次咨询游戏埋点
            const data = {
                event: 'REGISTER_FIRST_CONSULT',
                eventId: this.detailsData.gameId
            }
            this.$api.commonsMonitorHit(data).then(res => { })

            if (thirdPartyServiceUrl && this.token) {
                const info = {
                    action: {
                        gameId: this.detailsData.gameId,
                        goodsCatalogueId: this.detailsData.goodsCatalogueId,
                        goodsNo: this.detailsData.goodsNo
                    }
                }
                // 商品咨询
                if (this.detailsData.consultLabel == 1) {
                    this.$api.getGameLabelServiceApi().then(res => {
                        if (res.success) {
                            this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                            const data = {
                                action: {
                                    goodsNoList: [this.detailsData.goodsNo]
                                }
                            }
                            this.$api.esRetrieveGoods(data).then(esRes => {
                                if (esRes.success) {
                                    const goodsInformation = {
                                        goodsId: this.detailsData.goodsNo,
                                        price: this.detailsData.price,
                                        poster: this.detailsData.goodsImg,
                                        gameId: this.detailsData.gameId,
                                        title: this.detailsData.title,
                                        link: window.location.href,
                                        desc: this.detailsData.description,
                                        goodsCatalogueId: this.detailsData.goodsCatalogueId,
                                        bargain: this.detailsData.bargain,
                                        labelList: esRes.data.length > 0 ? esRes.data[0].labelList : [],
                                        compensation: this.detailsData.compensation,
                                        isConfidenceBuy: this.detailsData.isConfidenceBuy,
                                        isHideConsult: true
                                    }
                                    this.$store.dispatch('ry/sendGoodsMsg', {
                                        targetId: res.data,
                                        content: goodsInformation
                                    })
                                    this.$store.commit('ry/SET_GOODS_CONSULT', goodsInformation)
                                    this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                                    this.$store.commit('ry/SET_ORDER_FLOW', [])
                                } else {
                                    this.$message.error(res.info)
                                }
                            })
                        }
                    })
                } else if (this.detailsData.consultLabel == 2) {
                    // 咨询客服
                    const info = {
                        action: {
                            gameId: this.detailsData.gameId,
                            goodsCatalogueId: this.detailsData.goodsCatalogueId,
                            goodsNo: this.detailsData.goodsNo
                        }
                    }
                    this.$api.getCustomerService(info).then(res => {
                        if (!res.data) {
                            this.$message({
                                message: '暂无客服值班',
                                type: 'error'
                            })
                            return
                        }
                        this.setSaveUserConsultGoods(res.data.id)
                        this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                        const data = {
                            action: {
                                goodsNoList: [this.detailsData.goodsNo]
                            }
                        }
                        this.$api.esRetrieveGoods(data).then(esRes => {
                            if (esRes.success) {
                                const goodsInformation = {
                                    goodsId: this.detailsData.goodsNo,
                                    price: this.detailsData.price,
                                    poster: this.detailsData.goodsImg,
                                    gameId: this.detailsData.gameId,
                                    title: this.detailsData.title,
                                    link: window.location.href,
                                    desc: this.detailsData.description,
                                    goodsCatalogueId: this.detailsData.goodsCatalogueId,
                                    bargain: this.detailsData.bargain,
                                    labelList: esRes.data.length > 0 ? esRes.data[0].labelList : [],
                                    compensation: this.detailsData.compensation,
                                    isConfidenceBuy: this.detailsData.isConfidenceBuy
                                }

                                this.$store.dispatch('ry/sendGoodsMsg', {
                                    targetId: res.data.id,
                                    content: goodsInformation
                                })
                                this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                                this.$store.commit('ry/SET_ORDER_FLOW', [])
                            } else {
                                this.$message.error(res.info)
                            }
                        })
                    })
                } else if (this.detailsData.consultLabel == 3) {
                    const par = {
                        goodsNo: this.detailsData.goodsNo
                    }
                    this.$api.consultSellerAPI(par).then(res => {
                        if (!res.success) {
                            this.$message({
                                message: res.info,
                                type: 'error'
                            })
                            return
                        }
                        this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                        this.$store.dispatch('ry/join', {
                            targetId: res.data.groupId,
                            conversationType: 3
                        })
                        this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                        this.$store.commit('ry/SET_ORDER_FLOW', [])
                    })
                }
            }
        }),
        setSaveUserConsultGoods(id) {
            const p = {
                action: {
                    goodsNo: this.goodsNo,
                    goodsCatalogueId: this.detailsData.goodsCatalogueId,
                    imUserId: id
                }
            }
            this.$api.saveUserConsultGoods(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                }
            })
        },
        /**
         * 商品所属客服链接
         */
        getCustomerServiceConfig() {
            return new Promise(resolve => {
                const p = {
                    action: {
                        gameId: this.detailsData.gameId,
                        goodsCatalogueId: this.detailsData.goodsCatalogueId
                    }
                }
                this.$store.dispatch('game/CustomerServiceConfig', p).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.customerServiceObj = res.data
                    // const _53code = document.createElement("script");
                    // const leng = res.data.consultUrl.split("/").length - 1;
                    // const type = res.data.consultUrl.split("/")[leng];
                    // _53code.setAttribute("data-callType", "callScript");
                    // _53code.src = `${this.cusUrl}${type}`;
                    // var s = document.getElementsByTagName("script")[0];
                    // s.parentNode.insertBefore(_53code, s);
                    // s.parentNode.insertBefore(_53code, s);
                    // setTimeout(() => {
                    //   var api = $53.createApi();
                    //   api.push("cmd", "comeinfo");
                    //   api.push("title", this.detailsData.title);
                    //   api.push("logo", this.detailsData.goodsImg);
                    //   api.push("content", `商品价格：${this.detailsData.price}元`);
                    //   api.push("curl", window.location.href);
                    //   api.query();
                    // }, 500);
                    resolve()
                })
            })
        },
        /**
         * 客服交易群
         */
        getListCustomerService() {
            const p = {
                action: {
                    gameId: this.detailsData.gameId,
                    goodsCatalogueId: this.detailsData.goodsCatalogueId,
                    linkType: 'OFFICIAL_GROUP_QQ'
                }
            }
            this.$api.listCustomerServicePublic(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.empty = false
                this.serviceData = res.data
            })
        },
        /**
         * 交易须知
         */
        getListTradingNotice() {
            const p = {
                action: {
                    gameId: this.detailsData.gameId,
                    goodsCatalogueId: this.detailsData.goodsCatalogueId
                }
            }
            this.$api.listTradingNotice(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.empty = false
                this.tradingNoticeData = res.data
            })
        },
        /**
         * 点击收藏事件
         */
        onCollectionChange() {

        },
        /**
         * 加入收藏
         */

        /**
         * 取消收藏
         */

        /**
         * 商品收藏状态
         */

        back() {
            this.$router.go(-1)
        },
        // 查看购买须知
        getNotice() {
            const data = {
                action: {
                    id: 42
                }
            }
            this.$api.articleDetail(data).then(res => {
                if (res.success) {
                    this.articleDetail = res.data
                    this.centerDialogVisible2 = true
                }
            })
        },
        // 商品浏览埋点
        dashboardMonitorGoodsView() {
            const data = {
                event: 'GOODS_VIEW',
                eventId: this.$route.params.goodsNo
            }
            this.$api.commonsMonitorHit(data).then(res => { })
        },
        // 设置详情导航和选中第一个tab名字
        async setGoodsTabTitle() {
            const that = this
            function setTabTitle() {
                return new Promise(resolve => {
                    that.tabTitle = [
                        {
                            title: '商品介绍',
                            value: 'goodsDesc'
                        },
                        {
                            title: '官方交易群',
                            value: 'qqGroup'
                        }
                    ]
                    if (that.stagePayConfig.isShow) {
                        that.tabTitle.splice(1, 0, {
                            title: that.stagePayConfig.name || '分期代付',
                            value: 'byStagePay'
                        })
                    }
                    if ((that.detailsData?.metadataModel?.components && that.detailsData?.metadataModel?.resources) || that.detailsData?.metadataModelUrl) {
                        that.tabTitle.unshift({
                            title: '游戏资产',
                            value: 'gameAssets'
                        })
                    }
                    resolve()
                })
            }
            if (that.detailsData.goodsNo) {
                await that.getStagePayConfig()
                await that.getUserCarouselList()
            }
            await setTabTitle()
            this.tabTitleName = this.tabTitle[0].value
        },
        filterVHTML(htmlStr) {
            return filterDirtyHTML(htmlStr)
        },
        abTrack() {
            window.collectEvent('product_detail_view', { is_new_user: this.userinfo?.isAbUser ? '1' : '0' })
        },
        async getStagePayConfig() {
            const params = {
                goodsNo: this.detailsData.goodsNo
            }
            const { data, success } = await this.$api.getStagePayConfigAPI(params)
            if (success) {
                this.stagePayConfig = { ...data }
            }
        },
        async getUserCarouselList() {
            try {
                const params = {
                    goodsNo: this.detailsData.goodsNo,
                    sellerId: this.detailsData.sellerId
                }
                const res = await this.$api.getUserCarouselListAPI(params)
                if (res.success) {
                    if (res.success) {
                        const carouselSellerVO = res?.data?.carouselSellerVO ?? null
                        const carouselViewsVO = res?.data?.carouselViewsVO ?? null
                        const commonCarouseItemVOS = res?.data?.commonCarouseItemVOS ?? []
                        if (carouselViewsVO != null) this.userCarouselList.push(carouselViewsVO)
                        if (carouselSellerVO != null) {
                            carouselSellerVO.headImage = 'https://oss.pzds.com/mobileV3/Frame20251016.png'
                            carouselSellerVO['isSamll'] = true
                            this.userCarouselList.push(carouselSellerVO)
                        }
                        if (Array.isArray(commonCarouseItemVOS) && commonCarouseItemVOS.length) {
                            this.userCarouselList = this.userCarouselList.concat([...commonCarouseItemVOS])
                        }
                    }
                }
            } catch (err) {
                console.log(err)
            }
        }
    },
    created() { },
    async mounted() {
        this.$route.meta.title = `${this.detailsData.simpleMessage} 账号编号${this.$route.params.goodsNo} 出售`
        this.show = !Object.keys(this.detailsData).length
        const { goodsNo, goodsCatalogueId, gameId } = this.$route.params
        this.$trackEvent({
            eventType: 'pageView',
            eventName: '商品详情页曝光',
            pageUrl: window.location.href,
            toPath: `/goodsDetails/${goodsNo}/${goodsCatalogueId}`,
            userId: this.userinfo?.id,
            goodsNo: goodsNo,
            gameId: this.detailsData?.gameId,
            goodsCatalogueName: '成品号'
        })
        // await this.getGoodsDetails();
        // this.getCustomerServiceConfig()
        if (this.goodsType === this.$enum.GOODS_TYPE.ID) {
            this.getListCustomerService()
        }
        // 设置详情导航和选中第一个tab名字
        this.setGoodsTabTitle()
        // this.getGoodsListPropertyConfig();
        if (this.token) {
            // this.getCollectionGoodsStatus()
            // 获取最优优惠券信息
            this.getOptimalCoupon(this.detailsData?.payOnline)
            // if(this.detailsData?.payOnline != 0) {
            //     // 线上交易才获取优惠券信息
            //     // 获取最优优惠券信息
            //     this.getOptimalCoupon()
            // }

        }

        // if (this.detailsData.bargain && openHackBargain) {
        // 	this.checkUserBargain()
        // }

        this.dashboardMonitorGoodsView()

        // TODO：临时移除
        // this.getSellerIsOnline()

        setTimeout(() => {
            window.addEventListener('scroll', this.handleGoodsScroll, true)
        }, 300)

        // 判断是否是点击砍价卡片进来
        if (this.bargainingState) {
            this.onekeyBargain()
            this.$store.commit('SET_BARGAINING_STATE', false)
            setTimeout(() => {
                window._czc && window._czc.push(['_trackEvent', '访问量', '砍价详情页面', this.$route.params.goodsNo])
            }, 1000)
        } else {
            setTimeout(() => {
                window._czc && window._czc.push(['_trackEvent', '访问量', '商品详情页面', this.$route.params.goodsNo])
            }, 1000)
        }
        this.$trackEvent({
            eventType: 'pageRefresh',
            trackParams: {
                eventName: '商品详情页页面刷新',
                userId: this.userinfo?.id,
                goodsNo: this.detailsData.goodsNo,
                gameId: this.detailsData.gameId,
                tagType: !!this.detailsData.share ? '限时秒杀' : '',
                pageSource: this.$route.query?.from || '',
                goodsCatalogueName: '成品号'
            }
        })
    },
    activated() {
        this.abTrack()
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleGoodsScroll, true)
        this.clearCountdownTimer()
    }
}
